<template>
    <div>

        <div class='swap exchange'>

            <div class='exchangefields'>
                <fieldset class='item'>
                    <!-- <legend>From:</legend> -->
                    <div class='maxbalance' :class="{ 'loading line': maxBalance == -1 }" @click='set_max_balance'>
                        Max:
                        <span v-show="maxSynthBalance != -1 && coins[from_currency].isSynth"> {{ maxSynthBalanceText }}
                            / </span>
                        <span v-show='maxBalance != -1'>{{ maxBalanceText }}</span>
                        <span v-show='susdWaitingPeriod' class='susd-waiting-period'>
                            <span class='tooltip'>
                                <img src='@/assets/clock-regular.svg' class='icon small'>
                                <span class='tooltiptext'>
                                    Cannot transfer during waiting period. {{ (susdWaitingPeriodTime).toFixed(0) }} secs
                                    left.
                                </span>
                            </span>
                        </span>
                        <span v-show="coins[from_currency].isSynth" class='tooltip'> [?]
                            <span class='tooltiptext'>
                                Max transferrable amount is {{ maxSynthBalanceText }}. You can free the remaining
                                balance by settling.
                            </span>
                        </span>
                    </div>
                    <ul>
                        <multiselect placeholder='From' v-model='fromCurrency' @input='handleMultiselectFrom'
                            :options='Object.keys(currencies)' :select-label="''" :deselect-label="''"
                            :selected-label="''" :option-height='20'>
                            <template slot="singleLabel" slot-scope="props">
                                <img :class="{ 'icon token-icon': true, [props.option + '-icon']: true }"
                                    :src='getTokenIcon(props.option)'>
                                <span class="option__title"> {{ currencies[props.option].symbol }}</span>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <img :class="{ 'icon token-icon': true, [props.option + '-icon']: true }"
                                        :src='getTokenIcon(props.option)'>
                                    <span class="option__title"> {{ currencies[props.option].symbol }}</span>
                                    <span class="option__small"></span>
                                </div>
                            </template>
                        </multiselect>
                        <li class='currencyInput'>
                            <input type="text" id="from_currency" :disabled='disabled' name="from_currency" value='0.00'
                                :style="{ backgroundColor: fromBgColor }" @input='set_to_amount' v-model='fromInput'>
                            <p class='actualvalue' v-show='swapwrapped'>
                                ≈ {{ actualFromValue }} {{ coins[from_currency].symbol }}
                            </p>
                        </li>
                    </ul>
                </fieldset>
                <fieldset class='item iconcontainer' @click='swapInputs'>
                    <img :src="publicPath + 'exchange-alt-solid.svg'" id='exchangeicon' />
                </fieldset>
                <fieldset class='item'>
                    <!-- <legend>To:</legend> -->
                    <div class='maxbalance2'>Max: <span></span> </div>
                    <ul>
                        <multiselect placeholder='To' v-model='toCurrency' @input='handleMultiselectTo'
                            :options='Object.keys(currencies)' :select-label="''" :deselect-label="''"
                            :selected-label="''" :option-height='20'>
                            <template slot="singleLabel" slot-scope="props">
                                <img :class="{ 'icon token-icon': true, [props.option + '-icon']: true }"
                                    :src='getTokenIcon(props.option)'>
                                <span class="option__title"> {{ currencies[props.option].symbol }}</span>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <img :class="{ 'icon token-icon': true, [props.option + '-icon']: true }"
                                        :src='getTokenIcon(props.option)'>
                                    <span class="option__title"> {{ currencies[props.option].symbol }}</span>
                                    <span class="option__small"></span>
                                </div>
                            </template>
                        </multiselect>
                        <li class='currencyInput'>
                            <input type="text" id="to_currency" name="to_currency" value="0.00" disabled
                                :style="{ backgroundColor: bgColor }" v-model='toInput'>
                            <p class='actualvalue' v-show='swapwrapped'>
                                ≈ {{ actualToValue }} {{ coins[this.to_currency].symbol }}
                            </p>
                        </li>
                    </ul>
                </fieldset>
            </div>
            <p v-show='currentPoolObj && !currentPoolObj.cryptoPool && fromInput > 0 && !crossAssetSwap'
                class='exchange-rate'>
                Exchange rate
                <span @click='swapExchangeRate' class='clickable underline'>
                    {{ getPair(swaprate) }}
                    <img src='@/assets/sync-solid.svg' class='swaprates-icon'>
                </span> (including fees):
                <span id="exchange-rate" @click='swapExchangeRate' class='clickable'>
                    {{ exchangeRateSwapped }}
                </span>
            </p>
            <p v-show='currentPoolObj && !currentPoolObj.cryptoPool && fromInput > 0 && crossAssetSwap'
                class='exchange-rate'>
                Exchange rate
                <span @click='swapExchangeRate' class='clickable underline'>
                    {{ getPairReversed(swaprate) }}
                    <img src='@/assets/sync-solid.svg' class='swaprates-icon'>
                </span> (including fees):
                <span id="exchange-rate" @click='swapExchangeRate' class='clickable'>
                    {{ exchangeRateSwappedCross }}
                </span>
            </p>
            <p v-show='currentPoolObj && currentPoolObj.cryptoPool && fromInput > 0' class='exchange-rate'>
                Exchange rate
                <span @click='swapExchangeRate' class='clickable underline'>
                    {{ getPair(swaprate) }}
                    <img src='@/assets/sync-solid.svg' class='swaprates-icon'>
                </span> (including fees):
                <span id="exchange-rate" @click='swapExchangeRate' class='clickable'>
                    {{ exchangeRateSwapped }}
                </span>
            </p>
            <p v-show='currentPoolObj && currentPoolObj.cryptoPool && fromInput > 0' class='exchange-rate'>
                Price impact: <span v-if='cryptoTradeSlippage > 0'
                    :class="{ 'price-impact': true, red: cryptoTradeSlippage > 0.03 }">{{ (cryptoTradeSlippage *
                    100).toFixed(2)}}%</span><span v-else>–</span>
            </p>
            <p v-show='fromInput > 0' class='best-pool-text'>
                Trade routed through:
                <span id="best-pool">
                    <span>
                        {{ bestPoolText }}
                    </span>
                    <span v-show="bestPool === 'Synthetix'">
                        <a href="https://resources.curve.finance/guides/cross-asset-swaps" target="_blank">[?]</a>
                    </span>
                </span>
            </p>
            <ul>
                <!-- <li v-show='bestPool !== null'>
                    <input id="inf-approval" type="checkbox" name="inf-approval" checked v-model='inf_approval'>
                    <label for="inf-approval">Infinite approval - trust {{bestPoolText}} contract forever</label>
                </li> -->
                <!-- TODO add all wrapped tokens -->
                <!-- <li v-show="['2pool', 'usdt'].some(p => pools.includes(p))">
                    <input id='swapc' type='checkbox' name='swapc' v-model = 'swapwrapped'>
                    <label for='swapc'>Swap 2pooled</label>

                    <input id='swapy' type='radio' name='swapy' :value='2' :checked='swapwrapped == 2' @click='handleCheck(2)' v-model = 'swapwrapped'>
                    <label for='swapy'>Swap y</label>
                </li> -->
            </ul>
            <high-usd-slippage-notice :slippage="effectiveMaxSlippage" :amount="toInput"
                :address="currencies[toCurrency].address" />
            <div>
                <button class='simplebutton advancedoptions' @click='showadvancedoptions = !showadvancedoptions'>
                    Advanced options
                    <span v-show='!showadvancedoptions'>▼</span>
                    <span v-show='showadvancedoptions'>▲</span>
                </button>
                <div v-show='showadvancedoptions'>
                    <fieldset>
                        <legend>Advanced options:</legend>



                        <div v-show='fromInput > 0' id='max_slippage'><span>Max slippage:</span>
                            <input id="slippage05" type="radio"
                                :checked="customSlippageDisabled && effectiveMaxSlippage === 0.5"
                                @click='maxSlippage = 0.5; customSlippageDisabled = true'>
                            <label for="slippage05">0.5%</label>

                            <input id="slippage02" type="radio"
                                :checked="customSlippageDisabled && effectiveMaxSlippage === 0.1"
                                @click='maxSlippage = 0.1; customSlippageDisabled = true'>
                            <label for="slippage02">0.1%</label>

                            <input id="custom_slippage" type="radio" :checked="!customSlippageDisabled"
                                @click='customippageDisabled = false'>
                            <label for="custom_slippage" @click='customSlippageDisabled = false'>
                                <input type="text" id="custom_slippage_input" :disabled='customSlippageDisabled'
                                    name="custom_slippage_input" v-model='maxInputSlippage'> %
                            </label>
                            <span class='tooltip' v-show='showSlippageTooLow'>
                                <img class='icon small hoverpointer warning'
                                    :src="publicPath + 'exclamation-circle-solid.svg'">
                                <span class='tooltiptext'>
                                    Max slippage value is likely too low and the transaction may fail
                                </span>
                            </span>
                        </div>
                        <gas-price></gas-price>
                    </fieldset>
                </div>
            </div>
            <p class='simple-error'
                v-show='exchangeRate <= 0.98 && !crossAssetSwap && currentPoolObj && !currentPoolObj.cryptoPool'>
                Warning! Exchange rate is too low!
            </p>
            <p class='simple-error' id='no-balance-synth'
                v-show='notEnoughBalanceSynth && !susdWaitingPeriod && +maxSynthBalanceText > 0'>
                Max balance you can use is {{ maxSynthBalanceText }}
            </p>
            <div class='simple-error pulse' v-show="susdWaitingPeriod">
                Cannot transfer {{ coins[from_currency].symbol }} during waiting period {{
                    (susdWaitingPeriodTime).toFixed(0) }} secs
                left
            </div>
            <div class='simple-error' v-show='errorEstimating'>
                Error estimating gas, your transaction may fail
            </div>

            <div class='simple-error' v-show='setMarketDisabled'>
                Your selected market cannot be traded on Synthetix outside of market hours.
            </div>

            <!-- <p class='simple-error synthsDisabled' v-show="[5,9].includes(from_currency) || [5,9].includes(to_currency)">
                Synths transfers may be <b>temporarily</b> disabled due to <a href='https://blog.synthetix.io/the-fomalhaut-release/' rel='noopener noreferrer'>Syntetix contract upgrades</a>. Will be enabled back shortly.
            </p> -->
            <p class='trade-buttons' v-show="(!readyPart2)">
                <button id="trade" @click='handle_trade' :disabled='selldisabled'>
                    Sell <span class='loading line' v-show='loadingAction'></span>
                </button>
            </p>
            <p class='trade-buttons' v-show='(crossAssetSwap && readyPart2)'>
                <button id="trade" @click='handle_trade_part2(null)' :disabled='selldisabled'>
                    Sell 2 / 2 <span class='loading line' v-show='loadingAction'></span>
                </button>
            </p>


            <div class='info-message gentle-message waiting-message' v-show='show_loading'>
                <span v-html='waitingMessage'></span>
                <span class='loading line'></span>
            </div>
            <div class='info-message gentle-message' v-show='estimateGas'>
                Estimated tx cost: ${{ (estimateGas * gasPrice / 1e9 * ethPrice).toFixed(config.display.txCostPrecision)
                }}
                <span v-show="crossAssetSwap">Transaction {{ crossAssetSwapTransactionNumber }} / 2 | Do not close or
                    refresh
                    browser until tx confirmation</span>

            </div>
            <p class='simple-error' id='no-balance' v-show='showNoBalanceWarning'>
                Not enough balance for
                <span v-show='!swapwrapped'>{{ coins[from_currency].symbol }}</span>
                <span v-show='swapwrapped'>{{ coins[from_currency].symbol }}</span>. <span>Swap is not available.</span>
            </p>
            <div class='info-message gentle-message' v-show='selldisabled && warningNoPool === null && fromInput > 0'>
                Swapping between {{ coins[from_currency].symbol }} and {{ coins[to_currency].symbol }} is not available
                currently
            </div>
            <div class='info-message gentle-message' v-show='warningNoPool !== null'>
                Swap not available. Please select {{ warningNoPool }} in pool select
            </div>
            <div class='info-message gentle-message' v-show='(crossAssetSwap && !readyPart2)'>
                Cross-asset swaps are in beta, <a href="https://resources.curve.finance/guides/cross-asset-swaps"
                    target="_blank">read about them here.</a>
            </div>

            <div class='info-message gentle-message cursor' v-show='nftDected'>
                You have an incomplete cross-asset swap, click below to complete.
            </div>

            <table class='tui-table showdesktoptransactions' v-show='showSwaps.length > 0'>
                <thead>
                    <tr>
                        <th>Route</th>
                        <th>Amount</th>
                        <th>Settlement</th>
                        <th>Complete Trade</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for='(swap) in showSwaps'>
                        <td> {{ swap.route }} <!-- {{ swap.tokenId }} --> </td>
                        <td> {{ swap.amountFormatted }} </td>
                        <td>
                            {{ (swap.time_to_settle > 0) ? swap.time_to_settle + ' seconds left' : 'Settled' }}
                        </td>
                        <td>
                            <button id="trade-btn" @click='handle_trade_part2(swap.token_info)'
                                v-show='(swap.time_to_settle == 0)'>
                                Complete Trade
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table class='tui-table showdesktoptransactions' v-show='unfinishedTrades.length > 0'>
                <thead>
                    <tr>
                        <th>Synth</th>
                        <th>Token ID</th>
                        <th>Settlement</th>
                        <th>Complete Trade</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for='(swap) in unfinishedTrades'>
                        <td>{{ swap.balanceFormat.toFixed(6) }} {{ swap.synthName }}</td>
                        <td> {{ swap.tokenId }} </td>
                        <td>
                            {{ (swap.time_to_settle > 0) ? swap.time_to_settle + ' seconds left' : 'Settled' }}
                        </td>
                        <td>
                            <button id="trade-btn" @click='recover_trade(swap.tokenId)'
                                v-show='(swap.time_to_settle == 0)'>
                                Complete Trade
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div id='modalinit' class='modal' v-show='showModal' @click.self='showModal = false'>>
                <div class='modal-content window white'>
                    <fieldset>
                        Choose which token to finish trade with:
                    </fieldset>
                    <select style="margin-top:5px;width: 100%;" class='tvision' v-model='optionOut'>
                        <option value="">Select Option</option>
                        <option v-for='(v, i) in swapOutOptions' :value='v'>{{ v }}</option>
                    </select>
                    <br />
                    <!-- <select class="optionOut" v-model="optionOut">
                  <option v-for="option in swapOutOptions" v-bind:value="option">{{ option }}</option>
                </select> -->
                    <button id="complete-btn" @click='complete_recovery_trade()'> Complete Swap </button>
                </div>
            </div>

            <div class='modal' v-show='showFailedGasEstimationModal' @click.self='showFailedGasEstimationModal = false'>
                <div class='modal-content failed-gas-estimation window white'>
                    <fieldset>
                        <legend class='redwarning'>
                            Risk of transaction not succeeding
                        </legend>
                        <div class='content'>
                            <p class='simple-error'>
                                Gas estimation for this transaction failed, which means there's a high probability that
                                this
                                transaction will fail if submitted.
                            </p>
                        </div>
                        <div class="button-container">
                            <button @click='showFailedGasEstimationModal = false' class='buttoncancel'>Cancel</button>
                            <button @click='handleBypassGasEstimationFailureWarning' class='buttonred'> Submit anyway
                            </button>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from './EventBus'
import config from '@/constants/config'
import pools, { poolIds, findPoolForCoinsIds, findPoolForSwapAddress } from '@/constants/pools'
import coins from '@/constants/coins'
import { truncWithXSignificantDecimals } from '@/utils/Number'
const REFERENCE_ASSETS = require('@/constants/reference-assets.js');

import {
    contractAbis, ERC20_abi, cERC20_abi, yERC20_abi, synthERC20_abi,
    synthetixExchanger_address, synthetixExchanger_ABI, cross_asset_swaps, cross_addet_swap_address, system_status_snx, system_status_snx_abi, crypto_router_address, crypto_router_abi
} from '@/constants/abis'
import { notify, notifyHandler, notifyNotification } from '../../init'

import erc721 from '@0xcert/ethereum-erc721/build/erc721.json';


import { contract, LENDING_PRECISION, PRECISION, gas as contractGas } from '../../contract'
import * as common from '../../utils/common'
import * as helpers from '../../utils/helpers'
import tradeStore from './tradeStore'
import { sequentialPromiseMap } from '@/utils/Async'

import * as gasPriceStore from '../common/gasPriceStore'
import GasPrice from '../common/GasPrice.vue'

import * as errorStore from '../common/errorStore'

import BN from 'bignumber.js'

import * as Comlink from 'comlink'

import Multiselect from 'vue-multiselect'
import HighUsdSlippageNotice from '@/components/common/HighUsdSlippageNotice'

import 'vue-multiselect/dist/vue-multiselect.min.css'
import { callMethod, sendSafe } from '@/utils/Calls'

let { setIntervalAsync, clearIntervalAsync } = require('set-interval-async/dynamic')

const { arrayToHashmap } = helpers;

export default {

    components: {
        GasPrice,
        Multiselect,
        HighUsdSlippageNotice,
    },

    data: () => ({
        config,
        pools: poolIds,
        coins,
        errorEstimating: null,
        showFailedGasEstimationModal: false,
        maxBalance: -1,
        maxSynthBalance: -1,
        susdWaitingPeriod: false,
        susdWaitingPeriodTime: 0,
        snxExchanger: null,
        from_currency: coins.hasOwnProperty("dai") ? 'dai' : Object.values(coins)[0].id, // 'dai' or first in list
        fromCurrency: coins.hasOwnProperty("dai") ? 'dai' : Object.values(coins)[0].id, // 'dai' or first in list
        to_currency: (coins.usdc && config.blockchainId !== 'arbitrum') ? 'usdc' : Object.values(coins)[1].id, // 'usdc' or first in list note: arbitrum needs coin 1 displayed
        toCurrency: (coins.usdc && config.blockchainId !== 'arbitrum') ? 'usdc' : Object.values(coins)[1].id, // 'usdc' or first in list
        fromInput: '1.00',
        toInput: '0.00',
        updateTimer: null,
        maxSlippage: null,
        disabled: true,
        bgColor: '#505070',
        fromBgColor: 'blue',
        exchangeRate: 'Not available',
        cryptoTradeSlippage: undefined,
        swaprate: false,
        nftDected: false,
        maxInputSlippage: '',
        customSlippageDisabled: true,
        inf_approval: true,
        showModal: false,
        optionOut: '',
        recoveryId: '',
        swapOutOptions: [],
        swapContracts: [],
        zapContracts: [],
        setMarketDisabled: false,
        coinsContracts: {},
        swapPromise: helpers.makeCancelable(Promise.resolve()),
        multipath: 0,
        swapwrapped: false,
        bestPool: null,
        get showadvancedoptions() {
            // TODO improve by calculating usd value of input and using this in the condition
            // deciding whether to show advanced options, rather than a fixed number of BTC/ETH
            return (
                localStorage.getItem('advancedoptions') === 'true' ||
                +this.fromInput > 5000 ||
                (coins[this.from_currency].type === REFERENCE_ASSETS.BTC && +this.fromInput > 0.5) ||
                (coins[this.from_currency].type === REFERENCE_ASSETS.ETH && +this.fromInput > 5)
            );
        },
        set showadvancedoptions(val) {
            localStorage.setItem('advancedoptions', val)
        },
        show_loading: false,
        waitingMessage: '',
        userInteracted: false,
        ethPrice: 0,
        estimateGas: 0,
        loadingAction: false,
        crossAssetSwap: false,
        interval: null,
        readyPart2: false,
        tokenId: null,
        tokenInfo: null,
        showSwaps: [],
        unfinishedTrades: [],
        crossAssetSwapTransactionNumber: 1,
        cryptoRouter: undefined,
        cryptoRouterMetaData: undefined,
    }),
    computed: {
        currentPoolObj() {
            if (this.bestPool === 'crypto-router') return { cryptoPool: true };
            return pools.getById(this.bestPool);
        },
        currencies() {
            const coinsArray = Array.from(Object.values(coins)).filter(({ isTradable }) => isTradable);
            let currencies;

            if (this.swapwrapped === false) {
                currencies = coinsArray.filter(({ isWrappedCoin, isLpToken }) => !isWrappedCoin && !isLpToken);
            } else if (this.swapwrapped == 1) {
                currencies = coinsArray.filter(({ wrappedCoinType }) => wrappedCoinType === 'compound');
            } else {
                currencies = coinsArray.filter(({ wrappedCoinType }) => wrappedCoinType === 'iearn');
            }

            return arrayToHashmap(currencies.map((coin) => [coin.id, coin]));
        },
        maxBalanceText() {
            return this.toFixed(this.maxBalance / this.precisions(this.from_currency))
        },
        maxSynthBalanceText() {
            if (isNaN(this.maxSynthBalance)) return '0.00'
            return this.toFixed(this.maxSynthBalance / this.precisions(this.from_currency))
        },
        notEnoughBalanceSynth() {
            return coins[this.from_currency].isSynth && BN(this.fromInput).gt(BN(this.maxSynthBalance).div(this.precisions(this.from_currency)))
        },
        actualFromValue() {
            if (!this.swapwrapped) return;
            return (this.fromInput * this.c_rate(this.from_currency, this.bestPool) * this.precisions(this.from_currency)).toFixed(2)
        },
        actualToValue() {
            if (!this.swapwrapped) return;
            return (this.toInput * this.c_rate(this.to_currency, this.bestPool) * this.precisions(this.to_currency)).toFixed(2)
        },

        bestPoolText() {
            if (this.bestPool === null) return 'Not available'
            if (this.bestPool === 'Synthetix') return 'Curve x Synthetix'
            if (this.bestPool === 'crypto-router') return 'Curve Smart Router'
            return pools.getById(this.bestPool).name;
        },
        selldisabled() {
            return this.bestPool === null;
        },
        allPools() {
            return poolIds;
        },
        warningNoPool() {
            const noPoolFoundAmongChecked = this.bestPool === null && this.fromInput !== '0';
            if (!noPoolFoundAmongChecked) return null;

            const otherAvailablePool = findPoolForCoinsIds(this.from_currency, this.to_currency);
            if (otherAvailablePool) return otherAvailablePool.name;

            return null
        },
        publicPath() {
            return process.env.BASE_URL
        },
        isCryptoPool() {
            return this.currentPoolObj?.cryptoPool;
        },
        exchangeRateSwapped() {
            if (this.swaprate) {
                return (
                    this.isCryptoPool ?
                        truncWithXSignificantDecimals(1 / this.exchangeRate) :
                        (1 / this.exchangeRate).toFixed(4)
                );
            } else {
                return this.exchangeRate
            }
        },
        exchangeRateSwappedCross() {
            if (this.swaprate)
                return (1 / this.exchangeRate).toFixed(8)
            else
                return this.exchangeRate
        },
        gasPrice() {
            return gasPriceStore.getGasFields({ forcePreEip1559: true }).gasPrice / 1e9;
        },
        showNoBalanceWarning() {
            return this.maxBalance != -1 && +this.fromInput > this.maxBalance / this.precisions(this.from_currency) && this.userInteracted
        },
        showSlippageTooLow() {
            return +this.effectiveMaxSlippage < 0.1
        },
        defaultMaxSlippage() {
            return (this.isCryptoPool || this.crossAssetSwap) ? 0.5 : 0.1;
        },
        effectiveMaxSlippage() {
            return (
                this.customSlippageDisabled ?
                    (this.maxSlippage || this.defaultMaxSlippage) :
                    this.maxInputSlippage
            );
        },
    },
    watch: {
        async from_currency(val, oldval) {
            if (val == this.to_currency) {
                this.to_currency = oldval;
            }

            if (!this.crossAssetSwap && this.fromCurrency !== config.nativeAssetId && this.bestPool !== 'crypto-router' && this.bestPool) {
                if (BN(await this.getCoinContract(this.from_currency).methods.allowance(contract.default_account || '0x0000000000000000000000000000000000000000', this.swapContracts[this.bestPool]._address).call()).gt(contract.max_allowance.div(BN(2)))) {
                    this.inf_approval = true;
                }
                else {
                    //this.inf_approval = false;
                }
            }
            if (this.fromCurrency == config.nativeAssetId) {
                this.inf_approval = true;
            }
            //this.swapExchangeRate()
            this.from_cur_handler()
        },
        to_currency(val, oldval) {
            //this.swapExchangeRate()
            this.to_cur_handler()
        },
        pools() {
            this.from_cur_handler()
        },
        swapwrapped(val) {
            this.from_cur_handler()
        },
        warningNoPool(val, oldval) {
            if (val !== null) {
                this.bgColor = 'red'
                this.toInput = '0.00'
                this.exchangeRate = 'Not available'
            }
        },
        exchangeRateSwapped() {
            if (this.swaprate) {
                return (1 / this.exchangeRate).toFixed(4)
            }
            else {
                return this.exchangeRate
            }
        },
        gasPrice() {
            if (!this.disabled) {
                this.set_to_amount()
            }
        },
        fromInput() {
            this.userInteracted = true
        },
    },
    async created() {
        //EventBus.$on('selected', this.selectPool)
        let unwatch = this.$watch(() => contract.web3 && contract.multicall, val => {
            this.mounted();
            unwatch()
        })

    },
    mounted() {
        contract.web3 && contract.multicall && this.mounted()
    },
    methods: {
        async mounted() {
            await this.setup();
            this.disabled = false;
            this.from_cur_handler()
            let promises = await Promise.all([helpers.getETHPrice()])
            this.ethPrice = promises[0]

            if (config.blockchainId === 'ethereum') {
                this.show_cross_asset_swaps();
                this.checkNFTs();
            }
        },
        swapInputs() {
            [this.fromInput, this.toInput] = [this.toInput, this.fromInput]
            this.from_currency = this.to_currency
            let fromCurrency = this.fromCurrency
            let toCurrency = this.toCurrency
            this.fromCurrency = toCurrency
            this.toCurrency = fromCurrency
            this.from_cur_handler()
        },
        swapExchangeRate() {
            if (isNaN(this.exchangeRate)) return;
            this.swaprate = !this.swaprate
        },
        getTokenIcon(token) {
            return helpers.getTokenIcon(token)
        },
        getPair(inverse = false) {
            let from = coins[this.from_currency].symbol
            let to = coins[this.to_currency].symbol
            from = helpers.capitalize(from)
            to = helpers.capitalize(to)
            if (!inverse) return from + '/' + to
            if (inverse) return to + '/' + from
        },
        getPairReversed(inverse = false) {
            let from = coins[this.from_currency].symbol
            let to = coins[this.to_currency].symbol
            from = helpers.capitalize(from)
            to = helpers.capitalize(to)
            if (inverse) return from + '/' + to
            if (!inverse) return to + '/' + from
        },
        toFixed(num) {
            if (num == '' || num == undefined || num == 0) return '0.00'
            if (!BN.isBigNumber(num)) num = +num
            if (!coins[this.from_currency].isFiat || !coins[this.to_currency].isFiat) return num.toFixed(8)
            return num.toFixed(2)
        },
        handleError(err) {
            console.error(err)
            this.waitingMessage = '',
                this.show_loading = false
            throw err;
        },

        handleCheck(val) {
            if (this.swapwrapped === val) this.swapwrapped = false;
            else this.swapwrapped = val
        },
        c_rates(coinId) {
            if (this.swapwrapped == 2 && (
                coinId === 'dai' ||
                coinId === 'usdc' ||
                coinId === 'usdt'
            )) {
                return contract.contracts.iearn.c_rates
            }

            if (this.swapwrapped == 2 && coinId === 'busd') {
                return contract.contracts.busd.c_rates
            }

            return contract.c_rates;
        },
        c_rate(coinId, poolId) {
            const coinIndex = this.getCoinIndex(coinId, poolId);
            return this.c_rates(coinId)[coinIndex]
        },
        getCoinContract(coinId) {
            return this.coinsContracts[coinId];
        },
        precisions(coinId) {
            return coins[coinId].decimals;
        },
        async highlight_input() {
            var balance = parseFloat(await this.getCoinContract(this.from_currency).methods.balanceOf(contract.default_account || '0x0000000000000000000000000000000000000000').call())
                / this.precisions(this.from_currency);
            if (this.fromInput > balance)
                this.fromBgColor = 'red'
            else
                this.fromBgColor = 'blue'
        },
        async from_cur_handler() {
            await this.set_from_amount(this.from_currency);
            await this.set_to_amount();
        },
        async to_cur_handler() {
            // Note: used to be logic in there to swap from & to if they were equal, it was
            // broken so it's been removed, add it back later if needed
            await this.set_to_amount();
        },
        setLoadingAction() {
            this.loadingAction = true
            setTimeout(() => this.loadingAction = false, 500)
        },
        handleBypassGasEstimationFailureWarning() {
            this.showFailedGasEstimationModal = false;
            this.handle_trade({ bypassGasEstimationFailureWarning: true });
        },
        async handle_trade({ bypassGasEstimationFailureWarning = false }) {
            this.estimateGas = null;
            if (this.loadingAction) return;
            this.userInteracted = true
            this.setLoadingAction();
            this.show_loading = true;
            //handle allowances
            const i = this.from_currency;
            const j = this.to_currency;
            let amount = BN(this.fromInput).times(this.precisions(i)).toFixed(0)
            let maxSlippage = this.effectiveMaxSlippage / 100;
            let min_dy = BN(this.toInput).times(this.precisions(j)).times(BN(1 - maxSlippage)).toFixed(0)
            let bestContract = contract;

            if (this.bestPool !== 'Synthetix' && this.bestPool !== 'crypto-router') {
                bestContract = contract.contracts[this.bestPool];
                if (contract.currentContract == this.bestPool) {
                    bestContract = contract;
                }
            }

            if (this.crossAssetSwap) {
                this.handle_cross_asset_trade(amount);
                return;
            }

            const isCryptoRouter = this.bestPool === 'crypto-router';
            let address = (
                isCryptoRouter ? crypto_router_address :
                    pools.getById(this.bestPool).isFakePlainPool ? bestContract.crypto_zap._address :
                        bestContract.swap._address
            );

            if (this.fromCurrency !== config.nativeAssetId) {
                this.waitingMessage = `Please approve ${this.fromInput} ${coins[this.from_currency].symbol} for exchange`
                var { dismiss } = notifyNotification(this.waitingMessage)
                try {
                    if (this.inf_approval) {
                        await common.ensure_underlying_allowance(this.from_currency, contract.max_allowance, address, this.swapwrapped, bestContract, isCryptoRouter)
                    } else {
                        await common.ensure_underlying_allowance(this.from_currency, amount, address, this.swapwrapped, bestContract, isCryptoRouter);
                    }
                    dismiss()
                }
                catch (err) {
                    dismiss()
                    this.handleError(err)
                }
            }

            let ethValue = 0;

            if (this.fromCurrency === config.nativeAssetId) {
                ethValue = amount;
            }

            if (isCryptoRouter) {
                const { _route, _indices, expectedTokenOutput } = this.cryptoRouterMetaData;

                console.log('swapping thru router')
                await callMethod({
                    contract: { exchange: this.cryptoRouter },
                    contractName: 'exchange',
                    fromAddress: contract.default_account,
                    methodName: 'exchange',
                    params: [amount, _route, _indices, min_dy],
                    extraData: {
                        ethValue,
                        ethereumContractGasEstimationFallback: 1000000,
                        bypassGasEstimationFailureWarning,
                    },
                    vueState: {
                        vueInstance: this,
                        initialWaitingMessage: 'Please confirm swap transaction',
                        pendingWaitingMessage: `Waiting for swap
                                                    <a href="[TX_URL]">transaction</a>
                                                    to confirm: no further action needed`,
                    },
                });
            } else {
                const pool = pools.getById(this.bestPool);
                const swapUnderlying = (pool.isMetaPool || pool.isLendingPool) && !this.swapwrapped;
                const exchangeMethod = (swapUnderlying || pool.isFakePlainPool) ? 'exchange_underlying' : 'exchange';

                const params = (pool.allowTradingEth && (i === 'eth' || j === 'eth')) ?
                    [this.getCoinIndex(this.resolveCurrency(pool.allowTradingEth, i), this.bestPool), this.getCoinIndex(this.resolveCurrency(pool.allowTradingEth, j), this.bestPool), amount, min_dy, true] :
                    [this.getCoinIndex(i, this.bestPool), this.getCoinIndex(j, this.bestPool), amount, min_dy];

                await callMethod({
                    contract: bestContract,
                    contractName: pool.isFakePlainPool ? 'crypto_zap' : pool.isForexMetaPool ? 'deposit_zap' : undefined,
                    fromAddress: contract.default_account,
                    methodName: exchangeMethod,
                    params,
                    extraData: {
                        ethValue,
                        ethereumContractGasEstimationFallback: {
                            methodName: 'deposit',
                            poolId: this.bestPool,
                        },
                        bypassGasEstimationFailureWarning,
                    },
                    vueState: {
                        vueInstance: this,
                        initialWaitingMessage: 'Please confirm swap transaction',
                        pendingWaitingMessage: `Waiting for swap
                                                    <a href="[TX_URL]">transaction</a>
                                                    to confirm: no further action needed`,
                    },
                });
            }



            this.from_cur_handler();
            let balance;
            if (this.fromCurrency !== config.nativeAssetId) {
                balance = await this.getCoinContract(this.from_currency).methods.balanceOf(contract.default_account || '0x0000000000000000000000000000000000000000').call();
            } else {
                balance = await contract.web3.eth.getBalance(contract.default_account || '0x0000000000000000000000000000000000000000');
            }
            if (!contract.default_account) balance = 0
            let maxAmount = balance / this.precisions(i)
            this.maxBalance = this.toFixed(maxAmount);
        },
        async show_dropped() {
            let ERC721 = new contract.web3.eth.Contract(erc721.ERC721.abi, '0x58a3c68e2d3aaf316239c003779f71acb870ee47');
            let addresstoCheck = contract.default_account;
            let tokenBalances = await ERC721.methods.balanceOf(addresstoCheck).call();
            let idToOwner = [];
            if (tokenBalances > 0) {
                let events = await ERC721.getPastEvents('Transfer', { fromBlock: 11660963 });

                events.map((event, i) => {
                    if (event.returnValues._from.toLowerCase() == addresstoCheck.toLowerCase()) {
                        if (!idToOwner[event.returnValues._tokenId]) {
                            idToOwner[event.returnValues._tokenId] = {}
                        }
                        idToOwner[event.returnValues._tokenId].from = event.returnValues._from
                    }
                    if (event.returnValues._to.toLowerCase() == addresstoCheck.toLowerCase()) {
                        if (!idToOwner[event.returnValues._tokenId]) {
                            idToOwner[event.returnValues._tokenId] = {}
                        }
                        idToOwner[event.returnValues._tokenId].to = event.returnValues._to
                    }
                });

                let unfinished_trades = [];
                if (Object.keys(idToOwner).length > 0) {
                    for (const [key, value] of Object.entries(idToOwner)) {
                        if (Object.keys(value).length == 1) {
                            unfinished_trades.push(key);
                        }
                    }
                }
                let unfinished_trades_details = [];
                this.crossAssetSwapContract = new contract.web3.eth.Contract(cross_asset_swaps, cross_addet_swap_address)
                await sequentialPromiseMap(unfinished_trades, async (token_id) => {
                    let tokenInfo = await this.crossAssetSwapContract.methods.token_info(token_id.toString()).call();
                    let synthName = await this.getSynth(tokenInfo.synth);

                    let trade = {
                        'tokenId': token_id,
                        'balance': tokenInfo.underlying_balance,
                        'balanceFormat': tokenInfo.underlying_balance / 1e18,
                        'synth': tokenInfo.synth,
                        'time_to_settle': tokenInfo.time_to_settle,
                        'synthName': synthName

                    }
                    unfinished_trades_details.push(trade)

                })

                this.unfinishedTrades = unfinished_trades_details

            }
        },
        getSynth(address) {
            const lcAddress = address.toLowerCase();
            return Array.from(Object.values(coins)).find(({ address }) => address?.toLowerCase() === lcAddress).id
        },
        async handle_cross_asset_trade(amount) {
            if (this.fromCurrency !== config.nativeAssetId) {
                if (this.inf_approval) {
                    // TODO refactor approveCrossAssetSwaps here and everywhere else to stop working w/ indices
                    await common.approveCrossAssetSwaps(coins[this.fromCurrency].address, contract.max_allowance, null, cross_addet_swap_address, this.swapwrapped, this.crossAssetSwapContract)
                }
                else {
                    // TODO refactor approveCrossAssetSwaps here and everywhere else to stop working w/ indices
                    await common.approveCrossAssetSwaps(coins[this.fromCurrency].address, amount, null, cross_addet_swap_address, this.swapwrapped, this.crossAssetSwapContract);
                }
            }

            //get type of to asset (to know which synth we are going to)
            let midSynthAddress = await this.midSynth(coins[this.toCurrency].type);
            let startAddress = coins[this.fromCurrency].address;

            let ethValue = 0;

            if (this.fromCurrency == config.nativeAssetId) {
                ethValue = amount;
            }

            console.log(startAddress, midSynthAddress, amount, 'startAddress, midSynthAddress, amount');

            let expectedAmount = await this.crossAssetSwapContract.methods.get_swap_into_synth_amount(startAddress, midSynthAddress, amount).call()
            let multiplier = 0.99;
            if (this.effectiveMaxSlippage >= 0.2 && this.effectiveMaxSlippage <= 5) {
                multiplier = (1 - (this.effectiveMaxSlippage / 100));
            }

            expectedAmount = BN(expectedAmount * multiplier).toFixed(0)

            let estimateGas = 0
            this.crossAssetSwapTransactionNumber = 1
            try {
                estimateGas = await this.crossAssetSwapContract.methods.swap_into_synth(startAddress, midSynthAddress, amount, expectedAmount).estimateGas({
                    from: contract.default_account,
                    value: ethValue,
                    gas: 2000000,
                });
                estimateGas = (estimateGas * 1.2);
                estimateGas = estimateGas.toFixed(0)
                this.estimateGas = (estimateGas * 1.2) * this.gasPrice / 1e9 * this.ethPrice
            } catch (e) {
                estimateGas = 1850000
                this.estimateGas = estimateGas * this.gasPrice / 1e9 * this.ethPrice
            }


            try {
                //console.log('startAddress, midSynthAddress, amount, expected', startAddress, midSynthAddress, amount, expectedAmount)
                let responseToken = await (await sendSafe(this.crossAssetSwapContract.methods.swap_into_synth(startAddress, midSynthAddress, amount, expectedAmount), {
                    from: contract.default_account,
                    value: ethValue,
                    gas: estimateGas,
                })).pe
                    .once('transactionHash', hash => {
                        console.log(hash, 'hash');
                        notifyHandler(hash)
                        this.waitingMessage = `Waiting for swap
                                              <a href='https://etherscan.io/tx/${hash}'>transaction</a>
                                              to confirm. Step 1/2. Do not close or refresh your browser.`;

                        this.awaitReceipt(hash);


                    })


            }
            catch (err) {
                console.log('error', err)
                this.handleError(err)
                errorStore.handleError(err)
            }

        },
        async awaitReceipt(hash, tokenid = null) {
            setTimeout(() => {
                contract.web3.eth.getTransactionReceipt(hash).then((receipt) => {
                    if (!receipt) {
                        this.awaitReceipt(hash);
                    } else {
                        if (!tokenid) {

                            receipt.logs.map((log) => {
                                if (log.topics[0] == '0x72946db909d02e0ff93d1e9ff43433f9740b00add96b36bd7df362987648bc8d') {
                                    console.log(log.topics[1]);
                                    let topic = contract.web3.eth.abi.decodeParameter('uint256', log.topics[1])
                                    this.handle_token_id(topic)

                                }
                            })
                        } else {
                            this.waitingMessage = ''
                            this.access_local_storage(tokenid, true)
                            this.show_cross_asset_swaps();
                        }


                    }
                })

            }, 1500)
        },
        async handle_token_id(token_id) {

            let tokenId = token_id
            this.access_local_storage(tokenId);
            this.tokenId = tokenId;

            this.tokenInfo = await this.crossAssetSwapContract.methods.token_info(tokenId).call();
            this.secondsLeft = this.tokenInfo.time_to_settle
            this.countDownTimer()
            this.show_cross_asset_swaps();
        },
        //we store token id in localstorage until a trade is complete, we can also remove one if it turns out to be empty
        async access_local_storage(tokenId = null, remove = false) {
            if (!tokenId && remove !== true) {
                return JSON.parse(localStorage.getItem("tokens") || "[]");
            } else if (tokenId && remove !== false) {
                //remove token from storage
                let existing_tokens = JSON.parse(localStorage.getItem("tokens") || "[]")
                existing_tokens.map((t, index) => {
                    if (t.tokenId == tokenId) {
                        if (index > -1) {
                            existing_tokens.splice(index, 1);
                        }
                    }
                })
                localStorage.setItem("tokens", JSON.stringify(existing_tokens));
            } else {
                let existing_tokens = JSON.parse(localStorage.getItem("tokens") || "[]")
                let newToken = {
                    'tokenId': tokenId,
                    'amount': BN(this.fromInput).times(this.precisions(this.from_currency)).toFixed(0),
                    'amountFormatted': this.fromInput,
                    'swap': `${this.fromCurrency} -> ${this.toCurrency}`,
                    'toCurrency_address': coins[this.toCurrency].address,
                    'midSynthType': coins[this.toCurrency].type
                }
                existing_tokens.push(newToken);
                localStorage.setItem("tokens", JSON.stringify(existing_tokens));
            }
        },
        async checkNFTs() {
            let ERC721 = new contract.web3.eth.Contract(erc721.ERC721.abi, '0x58a3c68e2d3aaf316239c003779f71acb870ee47');
            let addresstoCheck = contract.default_account;
            let tokenBalances = await ERC721.methods.balanceOf(addresstoCheck).call();
            let existing_tokens = await this.access_local_storage();
            //ideally it would be best to check if the token detected is also the one in local storage
            if (tokenBalances > 0 && existing_tokens.length == 0) {
                this.nftDected = true;
                this.show_dropped();
            }
        },
        async show_cross_asset_swaps() {
            let existing_tokens = await this.access_local_storage();
            let token_info;
            let pendingSeconds = 0;
            if (!this.crossAssetSwapContract) {
                this.crossAssetSwapContract = new contract.web3.eth.Contract(cross_asset_swaps, cross_addet_swap_address)
            }
            this.showSwaps = [];
            await sequentialPromiseMap(existing_tokens, async (t, key) => {
                try {
                    token_info = await this.crossAssetSwapContract.methods.token_info(t.tokenId.toString()).call();

                    if (token_info.underlying_balance > 0) {

                        if (contract.default_account.toLowerCase() === token_info.owner.toLowerCase()) {
                            let swap = {
                                'synth': token_info.synth,
                                'time_to_settle': token_info.time_to_settle,
                                'route': t.swap,
                                'amountFormatted': t.amountFormatted,
                                'token_info': t.tokenId.toString()
                            }
                            if (token_info.time_to_settle > 0) {
                                pendingSeconds = token_info.time_to_settle
                                if (pendingSeconds > 0) {
                                    this.update_seconds(key);
                                }
                            }
                            this.showSwaps.push(swap)
                        }
                    } else {
                        //remove token as it's been consumed
                        this.access_local_storage(t.tokenId.toString(), true)
                    }
                } catch (e) {
                    //the token does not appear to be valid
                    this.access_local_storage(t.tokenId.toString(), true)
                }




            })
        },
        async update_seconds(key) {
            let callAgain = false;
            let loops = 0;
            setTimeout(() => {
                this.showSwaps.map((swap, index) => {
                    if (key === index) {
                        if (swap.time_to_settle > 0) {
                            swap.time_to_settle = swap.time_to_settle - 1;
                            if (swap.time_to_settle > 0) {
                                callAgain = true;
                                loops++;
                            } else {
                                callAgain = false;
                            }
                        }
                    }
                })
                if (callAgain) {
                    this.update_seconds(key);
                } else {
                    callAgain = false;
                    //update the table which should in theory show complete trade button
                    this.show_cross_asset_swaps();
                }

            }, 1010)
        },
        //this is what happens if a trade is disappeared.
        async recover_trade(token) {
            this.showModal = true
            this.recoveryId = token.toString();
            let tokenInfo = await this.crossAssetSwapContract.methods.token_info(token.toString()).call();
            console.log(tokenInfo, 'tokenInfo', 'tokenInfo.synth', tokenInfo.synth);
            let synthName = await this.getSynth(tokenInfo.synth);
            let options;
            if (synthName == 'seth') {
                options = ['eth', 'seth']
            } else if (synthName == 'sbtc') {
                options = ['renbtc', 'wbtc', 'sbtc']
            } else if (synthName == 'seur') {
                options = ['eurs', 'seur']
            } else if (synthName == 'susd') {
                options = ['dai', 'usdc', 'usdt', 'susd']
            } else if (synthName == 'slink') {
                options = ['link', 'slink']
            }
            console.log(options, synthName);
            this.swapOutOptions = options;
        },
        async complete_recovery_trade() {
            this.showModal = false;
            let tokenInfo = await this.crossAssetSwapContract.methods.token_info(this.recoveryId.toString()).call();

            let midSynthAddress = tokenInfo.synth;
            let toAddress = coins[this.optionOut].address
            let amount = tokenInfo.underlying_balance;
            this.begin_part_2_trade(midSynthAddress, toAddress, amount, this.recoveryId.toString(), true)

        },
        async withdrawSynth(tokenId) {
            let tokenInfo = await this.crossAssetSwapContract.methods.token_info(tokenId.toString()).call();
            let balanceToTakeOut = tokenInfo.underlying_balance;
            let estimateGas = 0;
            try {
                estimateGas = await this.crossAssetSwapContract.methods.withdraw(tokenId.toString(), balanceToTakeOut).estimateGas({
                    from: contract.default_account,
                    gas: 1500000,
                });
                estimateGas = estimateGas * 1.2
                estimateGas = estimateGas.toFixed(0)
                this.estimateGas = (estimateGas * 1.2) * this.gasPrice / 1e9 * this.ethPrice
            } catch (e) {
                estimateGas = 750000;
                this.estimateGas = 750000 * this.gasPrice / 1e9 * this.ethPrice
            }
            this.crossAssetSwapTransactionNumber = 2

            await (await sendSafe(this.crossAssetSwapContract.methods.withdraw(tokenId.toString(), balanceToTakeOut), {
                from: contract.default_account,
                gas: estimateGas,
            })).pe
                .once('transactionHash', hash => {
                    console.log(hash, 'hash');
                    notifyHandler(hash)
                    this.waitingMessage = `Waiting for withdraw
                                          <a href='https://etherscan.io/tx/${hash}'>transaction</a>
                                          to confirm. Step 2/2`
                })

            await this.access_local_storage(tokenId, true)
            await this.show_cross_asset_swaps();

        },
        async begin_part_2_trade(midSynthAddress, toAddress, amount, tokenId, from_recovery = null) {

            if (midSynthAddress.toLowerCase() == toAddress.toLowerCase()) {
                //perform withdraw
                this.withdrawSynth(tokenId);
                return;
            }

            let expectedAmount = await this.crossAssetSwapContract.methods.get_swap_from_synth_amount(midSynthAddress, toAddress, amount).call()
            expectedAmount = expectedAmount * 0.99;
            expectedAmount = BN(expectedAmount).toFixed(0)

            let estimateGas = 0;
            try {
                estimateGas = await this.crossAssetSwapContract.methods.swap_from_synth(tokenId, toAddress, amount, expectedAmount).estimateGas({
                    from: contract.default_account,
                    gas: 1800000,
                });
                estimateGas = estimateGas * 1.2
                estimateGas = estimateGas.toFixed(0)
                this.estimateGas = (estimateGas * 1.2) * this.gasPrice / 1e9 * this.ethPrice
            } catch (e) {
                estimateGas = 750000;
                this.estimateGas = 750000 * this.gasPrice / 1e9 * this.ethPrice
            }
            this.crossAssetSwapTransactionNumber = 2


            let response = await (await sendSafe(this.crossAssetSwapContract.methods.swap_from_synth(tokenId, toAddress, amount, expectedAmount), {
                from: contract.default_account,
                gas: estimateGas,
            })).pe
                .once('transactionHash', hash => {
                    console.log(hash, 'hash');
                    notifyHandler(hash)
                    this.waitingMessage = `Waiting for swap
                                          <a href='https://etherscan.io/tx/${hash}'>transaction</a>
                                          to confirm. Step 2/2`

                    this.awaitReceipt(hash, tokenId);
                })

            try {
                //we check the token, if it has been successful the call should fail as the token doesnt exist
                let checkToken = await this.crossAssetSwapContract.methods.token_info(tokenId.toString()).call();

            } catch (e) {
                //on fail which means success we can remove from local storage

                if (from_recovery) {

                    let unfinished_trades = this.unfinishedTrades
                    unfinished_trades.map((swap, i) => {
                        console.log(swap, i);
                        if (swap.tokenId == tokenId) {
                            unfinished_trades.splice(i, 1);
                        }
                    })

                    console.log(unfinished_trades);
                    if (!unfinished_trades.length) {
                        console.log('Removing trades ....');
                        this.nftDected = false;
                        this.unfinishedTrades = [];
                    }
                    this.unfinishedTrades = unfinished_trades;

                    await this.checkNFTs();

                }



                await this.access_local_storage(tokenId, true)
                await this.show_cross_asset_swaps(); //do this so it hides the completed swap

            }
        },
        async handle_trade_part2(token_id = null) {
            try {

                let tokenId;
                let amount;
                let toAddress;
                let midSynthAddress;
                let midSynthType;

                if (token_id) {
                    //this mean we are picking an abandoned swap
                    let tokenInfo = await this.crossAssetSwapContract.methods.token_info(token_id.toString()).call();
                    let existing_tokens = await this.access_local_storage()
                    existing_tokens.map((t) => {
                        if (t.tokenId == token_id) {
                            toAddress = t.toCurrency_address
                            midSynthType = t.midSynthType
                        }
                    })

                    console.log('midSynthType', midSynthType);

                    midSynthAddress = await this.midSynth(midSynthType);
                    tokenId = token_id.toString();
                    amount = tokenInfo.underlying_balance;

                } else {
                    toAddress = coins[this.toCurrency].address

                    tokenId = BN(this.tokenId);
                    amount = BN(this.tokenInfo.underlying_balance)
                    midSynthAddress = await this.midSynth(coins[this.toCurrency].type);
                }

                this.begin_part_2_trade(midSynthAddress, toAddress, amount, tokenId)

            }
            catch (err) {
                this.handleError(err)
                errorStore.handleError(err)
            }

        },

        async countDownTimer() {
            if (this.secondsLeft > 0) {
                setTimeout(() => {
                    this.waitingMessage = `Awaiting settlement: ${this.secondsLeft} seconds left. Please wait for part 2 / 2`;
                    this.secondsLeft -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                this.readyPart2 = true;
                this.waitingMessage = `Please complete your trade by clicking the Complete button`;
            }
        },
        async midSynth(coinType) {
            if (coinType === REFERENCE_ASSETS.BTC) {
                return coins.sbtc.address
            }
            if (coinType === REFERENCE_ASSETS.USD) {
                return coins.susd.address
            }
            if (coinType === REFERENCE_ASSETS.EUR) {
                return coins.seur.address
            }
            if (coinType === REFERENCE_ASSETS.ETH) {
                return coins.seth.address
            }
            if (coinType === REFERENCE_ASSETS.LINK) {
                return coins.slink.address
            }
        },
        async set_from_amount(coinId) {
            const coinContract = this.getCoinContract(coinId)
            const coinAddress = coinContract._address;

            const balanceCalls = [
                [
                    coinAddress,
                    coinContract.methods.balanceOf(contract.default_account || '0x0000000000000000000000000000000000000000').encodeABI()
                ],
            ];

            if (config.blockchainId === 'ethereum') {
                if (coins[coinId].isSynth) {
                    balanceCalls.push([coinAddress,
                        this.getCoinContract(coinId).methods.transferableSynths(contract.default_account || '0x0000000000000000000000000000000000000000').encodeABI()])
                    let currencyKey = '0x7355534400000000000000000000000000000000000000000000000000000000'
                    if (coinId === 'sbtc')
                        currencyKey = '0x7342544300000000000000000000000000000000000000000000000000000000'
                    balanceCalls.push([this.snxExchanger._address,
                    this.snxExchanger.methods
                        .maxSecsLeftInWaitingPeriod(contract.default_account, currencyKey)
                        .encodeABI()
                    ])
                }
            }

            let amounts = [];
            let balances = [];
            if (coinId == config.nativeAssetId) {
                let ethBalances = await contract.web3.eth.getBalance(contract.default_account)
                amounts[0] = ethBalances;
                balances[0] = ethBalances;
            } else {
                let aggcalls = await contract.multicall.methods.aggregate(balanceCalls).call()
                balances = aggcalls[1].map(hex => contract.web3.eth.abi.decodeParameter('uint256', hex))
                amounts = balances.map(balance => contract.default_account ? balance : 0)
            }
            this.maxBalance = amounts[0]

            let highlight_red = this.fromInput > balances[0] / this.precisions(this.from_currency)
            if (coins[coinId].isSynth) {
                this.maxSynthBalance = amounts[1]
                this.susdWaitingPeriod = (+amounts[2] != 0)
                this.susdWaitingPeriodTime = +amounts[2]
                highlight_red = this.fromInput > this.maxSynthBalance / this.precisions(this.from_currency)
                if (this.susdWaitingPeriod) highlight_red = true
            }

            if (highlight_red) this.fromBgColor = 'red'
            else this.fromBgColor = 'blue'
        },
        setExchangeRate(exchangeRate) {
            if (this.crossAssetSwap) {
                this.exchangeRate = (+exchangeRate).toFixed(8)
                return;
            }
            if (+exchangeRate <= 0.98) this.bgColor = 'red'
            else this.bgColor = '#505070'
            if (isNaN(+exchangeRate)) {
                this.exchangeRate = "Not available"
            }
            else {
                this.exchangeRate = this.isCryptoPool ?
                    truncWithXSignificantDecimals(exchangeRate, 4) :
                    (+exchangeRate).toFixed(4);
            }
        },
        /*get approximate exchange rate for cross asset swap*/
        async getCrossAssetRate(from, to, amount) {

            this.crossAssetSwapContract = new contract.web3.eth.Contract(cross_asset_swaps, cross_addet_swap_address)

            //we are swapping to a synth
            if (coins[this.toCurrency].isSynth) {
                let promise = await this.crossAssetSwapContract.methods.get_swap_into_synth_amount(from, to, amount.toFixed(0)).call();
                return promise;
            }

            let promise = await this.crossAssetSwapContract.methods.get_estimated_swap_amount(from, to, amount.toFixed(0)).call();
            return promise;

        },
        getPoolsCalls() {
            const selectedPoolIds = this.pools;
            const selectedPools = pools.filter(({ id }) => selectedPoolIds.includes(id));

            const swappablePools = (
                this.swapwrapped === 1 ? selectedPools.filter(({ id }) => id === 'compound' || id === 'usdt') :
                    !this.swapwrapped ? selectedPools :
                        []
            );

            // Gather pools that contain both coins
            const relevantPools = swappablePools.filter(({
                coins,
                underlyingCoins,
                metaCoins,
                allowTradingEth,
                isMetaPool,
            }) => ((
                coins.some(({ id }) => id === this.resolveCurrency(allowTradingEth, this.from_currency)) ||
                underlyingCoins?.some(({ id }) => id === this.from_currency) ||
                metaCoins?.some(({ id }) => id === this.from_currency)
            ) && (
                    coins.some(({ id }) => id === this.resolveCurrency(allowTradingEth, this.to_currency)) ||
                    underlyingCoins?.some(({ id }) => id === this.to_currency) ||
                    metaCoins?.some(({ id }) => id === this.to_currency)
                    /**
                     * If this pool is a meta pool, only consider it relevant if the trade involves
                     * its main coin and one of its meta coins, iow if the trade isn't involving only
                     * two meta coins that can be more effectively routed through the base pool itself.
                     */
                ) && (
                    !isMetaPool ||
                    !(
                        metaCoins?.some(({ id }) => id === this.from_currency) &&
                        metaCoins?.some(({ id }) => id === this.to_currency)
                    )
                ))).filter(({ id }) => id !== 'atricrypto2'); // Disable atricrypto2 trades

            return relevantPools.map((pool) => this.getPoolCall(pool, this.fromInput));
        },
        resolveCurrency(allowTradingEth, currency) {
            return (allowTradingEth && currency === 'eth') ? 'weth' : currency;
        },
        getPoolCall(pool, fromInput) {
            const {
                id,
                isMetaPool,
                isLendingPool,
                addresses: { swap: swapAddress, deposit: zapAddress },
                allowTradingEth,
            } = pool;

            const swapUnderlying = isMetaPool || isLendingPool;

            const dyMethod = swapUnderlying ? 'get_dy_underlying' : 'get_dy';
            const fromCoin = coins[this.resolveCurrency(allowTradingEth, this.from_currency)];
            const fromIndex = this.getCoinIndex(this.resolveCurrency(allowTradingEth, this.from_currency), id);
            const toIndex = this.getCoinIndex(this.resolveCurrency(allowTradingEth, this.to_currency), id);
            const dx = BN(fromInput).times(fromCoin.decimals).toFixed(0, BN.ROUND_DOWN);


            if (pool.isFakePlainPool || pool.isForexMetaPool) {
                //get_dy but on the zap
                return [
                    zapAddress,
                    this.zapContracts[id].methods.get_dy_underlying(fromIndex, toIndex, dx).encodeABI(),
                ];
            }

            return [
                swapAddress,
                this.swapContracts[id].methods[dyMethod](fromIndex, toIndex, dx).encodeABI(),
            ];
        },
        getCoinIndex(coinId, poolId) {
            const pool = pools.getById(poolId);
            const contractCoinsAddresses = (
                pool.isMetaPool ?
                    contractAbis[poolId].coins.slice(0, -1).concat(contractAbis[poolId].meta_coins) :
                    contractAbis[poolId][pool.isLendingPool ? 'underlying_coins' : 'coins']
            ).map((a) => a.toLowerCase());
            const coin = coins[coinId];

            const index = contractCoinsAddresses.indexOf(coin.address.toLowerCase());

            // Should never happen, left there for debugging purposes while this PR is fully tested
            if (index === -1) {
                console.log('getCoinIndex', { coinId, poolId, isMetaPool: pool.isMetaPool, isLendingPool: pool.isLendingPool });
                console.log('getCoinIndex', { contractCoinsAddresses, coin, address: coin.address.toLowerCase() });
                console.log({ index: contractCoinsAddresses.indexOf(coin.address.toLowerCase()) });
                debugger;
            }

            return index;
        },
        async realComparePools(calls) {
            const originalFromCurrency = this.from_currency;
            const originalToCurrency = this.to_currency;
            // console.log(calls, 'calls')
            let aggcalls = await contract.multicall.methods.aggregate(calls).call()
            let decoded = aggcalls[1].map(hex => contract.web3.eth.abi.decodeParameter('uint256', hex))
            let poolRates = calls.map((call, i) => [call[0], decoded[i]])
            //console.log(poolRates, 'poolRates')

            // In its current state, the app has race conditions when selecting from/to currencies,
            // so this check ensures that if such a race condition happens, we fail smoothly by
            // returning an empty result.
            if (
                originalFromCurrency !== this.from_currency ||
                originalToCurrency !== this.to_currency
            ) {
                return [null, 0];
            }

            return poolRates.reduce((a, b) => {
                const poolId1 = findPoolForSwapAddress(a[0]).id;
                const poolId2 = findPoolForSwapAddress(b[0]).id;
                const gas1 = this.calculateGas(poolId1)[0]
                const gas2 = this.calculateGas(poolId2)[0]
                const precisions = this.precisions(this.to_currency)
                return ((a[1] / precisions) - gas1) > ((b[1] / precisions) - gas2) ? a : b
            })
        },
        calculateGas(poolId) {
            let txPricePool = 0
            const i = this.getCoinIndex(this.from_currency, poolId);
            const j = this.getCoinIndex(this.to_currency, poolId);
            const poolgas = contractGas.swap[poolId].exchange_underlying(i, j) / 2;
            txPricePool = poolgas * this.gasPrice / 1e9 * this.ethPrice;
            //console.log(txPricePool, poolId)
            return [txPricePool]
        },
        async set_to_amount() {
            this.interval && !this.interval.stopped && clearIntervalAsync(this.interval)
            this.bestPool = null;
            this.crossAssetSwap = false;
            let exchangeRate;
            let bestdy_ = 0;
            let bestPool;

            try {
                if (this.fromInput == 0) {
                    this.disabled = false;
                    this.toInput = '0.00';
                    return;
                }

                const isCryptoSwap = (
                    coins[this.fromCurrency] &&
                    coins[this.toCurrency] &&
                    coins[this.fromCurrency].type !== coins[this.toCurrency].type
                );

                let isUsingSmartRouter = false;
                const cryptoPools = pools.filter(({ cryptoPool }) => cryptoPool === true);
                const isOneHopCryptoPoolSwap = (
                    isCryptoSwap &&
                    cryptoPools.some((pool) => (
                        pool.isMetaPool ? (
                            [...pool.coins, ...pool.metaCoins].some((coin) => coin === coins[this.fromCurrency]) &&
                            [...pool.coins, ...pool.metaCoins].some((coin) => coin === coins[this.toCurrency])
                        ) : (
                            (
                                pool.coins.some((coin) => coin.id === coins[this.fromCurrency].id) ||
                                pool.coinsInPlaceReplacements.some((coin) => coin.id === coins[this.fromCurrency].id)
                            ) && (
                                pool.coins.some((coin) => coin.id === coins[this.toCurrency].id) ||
                                pool.coinsInPlaceReplacements.some((coin) => coin.id === coins[this.toCurrency].id)
                            )
                        )
                    ))
                );

                if (isCryptoSwap && config.blockchainId === 'ethereum') {
                    const fromCoin = coins[this.fromCurrency];
                    const toCoin = coins[this.toCurrency];

                    this.cryptoRouter = new contract.web3.eth.Contract(crypto_router_abi, crypto_router_address);
                    const canRoute = await this.cryptoRouter.methods.can_route(fromCoin.address, toCoin.address).call();
                    isUsingSmartRouter = canRoute;

                    if (canRoute) {
                        const dx = BN(this.fromInput).times(fromCoin.decimals).toFixed(0, BN.ROUND_DOWN);
                        const { 0: _route, 1: _indices, 2: expectedTokenOutput } = await this.cryptoRouter.methods.get_exchange_routing(fromCoin.address, toCoin.address, dx).call();
                        this.cryptoRouterMetaData = { _route, _indices, expectedTokenOutput };

                        const expectedTokenOutputBN = BN(expectedTokenOutput).div(toCoin.decimals);

                        this.bestPool = 'crypto-router';
                        bestPool = this.bestPool

                        exchangeRate = expectedTokenOutputBN.div(this.fromInput);
                        bestdy_ = expectedTokenOutputBN;
                        this.toInput = expectedTokenOutputBN.toNumber();
                        this.setExchangeRate(exchangeRate.toNumber());

                        // Estimate slippage
                        const smallUnit = Math.max(
                            ((fromCoin.type === REFERENCE_ASSETS.USD || fromCoin.type === REFERENCE_ASSETS.EUR) ? 1 : 1e-5),
                            Math.log10(fromCoin.decimals)
                        );

                        const dxSmallUnit = BN(smallUnit).times(fromCoin.decimals).toFixed(0, BN.ROUND_DOWN);
                        const { 2: expectedTokenOutputSmallUnit } = await this.cryptoRouter.methods.get_exchange_routing(fromCoin.address, toCoin.address, dxSmallUnit).call();

                        const exchangeRateSmallestUnit = BN(expectedTokenOutputSmallUnit).div(toCoin.decimals).times(1 / smallUnit).toNumber();
                        const slippage = 1 - (exchangeRate.toNumber() / exchangeRateSmallestUnit);
                        this.cryptoTradeSlippage = slippage;
                        this.crossAssetSwap = false;
                    }
                }

                // This conditions makes the ui route through a single crypto pool (like tricrypto) if we're handling
                // a cryptoswap that didn't yield any valid route from the router, but that can be routed by a single
                // pool instead. This is meant to fix an issue (?) with the router where e.g. weth->usdt doesn't yield
                // a valid route despite the fact it can be router through tricrypto in a single hop.
                const isOneHopCryptoSwapThatDidntYieldRoute = isOneHopCryptoPoolSwap && !isUsingSmartRouter;
                if (!isCryptoSwap || isOneHopCryptoSwapThatDidntYieldRoute) {

                    this.swapPromise.cancel();

                    const calls = this.getPoolsCalls();
                    const hasNoNativeSwapOnCurve = calls.length === 0;
                    const promises = [hasNoNativeSwapOnCurve ? [null, 0] : this.realComparePools(calls)];

                    this.swapPromise = helpers.makeCancelable(Promise.all(promises))
                    const result = await this.swapPromise
                    const [swapAddress, dy] = result[0]

                    let poolId = swapAddress !== null ? findPoolForSwapAddress(swapAddress).id : null;
                    let dy_ = BN(dy).div(this.precisions(this.to_currency))
                    exchangeRate = BN(dy_).div(BN(this.fromInput))
                    bestdy_ = dy_
                    this.bestPool = poolId;
                    bestPool = this.bestPool;

                    this.setMarketDisabled = false;
                    if (bestPool !== null) {
                        //show converted exchange rate when swapping wrapped coins?
                        this.toInput = this.toFixed(BN(this.fromInput).times(BN(exchangeRate)));
                        if (this.swapwrapped) {
                            let cdy_ = bestdy_ * this.c_rate(this.to_currency, bestPool) * this.precisions(this.to_currency)
                            let cdx_ = this.fromInput * this.c_rate(this.from_currency, bestPool) * this.precisions(this.from_currency)
                            exchangeRate = (cdy_ / cdx_)
                        }
                        this.setExchangeRate(exchangeRate)

                        if (this.currentPoolObj?.cryptoPool) {
                            const smallUnit = Math.max(
                                (coins[this.fromCurrency].type === REFERENCE_ASSETS.USD ? 1 : 1e-8),
                                Math.log10(coins[this.fromCurrency].decimals)
                            );
                            const calls = [this.getPoolCall(this.currentPoolObj, smallUnit)];
                            let aggcalls = await contract.multicall.methods.aggregate(calls).call()
                            let decoded = aggcalls[1].map(hex => contract.web3.eth.abi.decodeParameter('uint256', hex))
                            const exchangeRateSmallestUnit = BN(decoded[0]).div(this.precisions(this.to_currency)).times(1 / smallUnit).toNumber();
                            const slippage = 1 - (exchangeRate.toNumber() / exchangeRateSmallestUnit);
                            this.cryptoTradeSlippage = slippage;
                        } else {
                            this.cryptoTradeSlippage = undefined;
                        }
                    }
                }
            }
            catch (err) {
                if (!err.canceled) {
                    console.error(err)
                    this.toInput = 0
                }
            }
            finally {
                this.set_from_amount(this.from_currency)
            }
        },
        async set_max_balance() {
            let balance;
            if (this.fromCurrency == config.nativeAssetId) {
                balance = await contract.web3.eth.getBalance(contract.default_account)
                balance = balance - 50000000000000000
            } else {
                if (coins[this.from_currency].isSynth) {
                    balance = await this.getCoinContract(this.from_currency).methods.transferableSynths(contract.default_account || '0x0000000000000000000000000000000000000000').call();
                    if (this.susdWaitingPeriod) balance = 0
                } else {
                    balance = await this.getCoinContract(this.from_currency).methods.balanceOf(contract.default_account || '0x0000000000000000000000000000000000000000').call();
                }
            }

            let amount = BN(balance).div(this.precisions(this.from_currency)).toFixed()
            this.fromInput = contract.default_account ? amount : 0
            await this.set_to_amount();
        },
        async setup() {
            // Initialize swap contracts for all pools
            this.swapContracts = arrayToHashmap(pools.map(({
                id,
                addresses: { swap: swapAddress },
            }) => [
                    id,
                    new contract.web3.eth.Contract(contractAbis[id].swap_abi, swapAddress),
                ]));

            // Initialize zap contracts for all pools
            this.zapContracts = arrayToHashmap(
                pools
                    .filter(({ addresses: { deposit: zapAddress } }) => !!zapAddress)
                    .map(({
                        id,
                        addresses: { deposit: zapAddress },
                    }) => [
                            id,
                            new contract.web3.eth.Contract(contractAbis[id].deposit_abi, zapAddress),
                        ])
            );

            // Initialize contracts for all coins
            this.coinsContracts = arrayToHashmap(Array.from(Object.values(coins)).map(({
                id,
                address,
                isSynth,
                wrappedCoinType,
            }) => {
                const tokenABI = (
                    wrappedCoinType === 'compound' ? cERC20_abi :
                        wrappedCoinType === 'iearn' ? yERC20_abi :
                            isSynth ? synthERC20_abi : ERC20_abi
                );

                return [
                    id,
                    new contract.web3.eth.Contract(tokenABI, address),
                ];
            }));

            this.snxExchanger = new contract.web3.eth.Contract(synthetixExchanger_ABI, synthetixExchanger_address)
        },

        handleMultiselectFrom(currency) {
            let from_currency = currency
            let to_currency = this.to_currency
            if (from_currency == this.to_currency)
                this.swapInputs()
            else
                this.from_currency = from_currency
        },

        handleMultiselectTo(currency) {
            let to_currency = currency
            let from_currency = this.from_currency
            if (to_currency == this.from_currency)
                this.swapInputs()
            else
                this.to_currency = to_currency
        },
    },


    beforeDestroy() {
        this.interval && clearIntervalAsync(this.interval)
    },
}
</script>

<style scoped>
fieldset {
    border: 0;
    margin: 0;
    padding: 0;
}

#poolselect {
    margin-bottom: 1em;
}

#poolselect>label:nth-of-type(1) {
    margin-left: 0;
}

#poolselect>label {
    margin-left: 1em;
}

.actualvalue {
    margin: 0.5em 0 0 0;
    text-align: right;
    font-size: 0.9em;
}

.exchange {
    width: 60%;
}

.cursor {
    cursor: pointer !important;
}

#best-pool .tooltiptext {
    text-align: left;
    padding-left: 1em;
}

.tui-table {
    width: 100%;
    margin-top: 1em;
    text-align: center;
}

.optionOut {
    width: 100%;
    padding: 6px;
    margin-top: 10px;
}

.tui-table td {
    padding: 8px;
}

.maxbalance.loading.line {
    display: block;
}

#complete-btn {
    margin-top: 8px;
}

.coins.renbtc {
    margin-top: 1em;
}

.pulse {
    animation: pulse 1s 3;
    margin-bottom: 8px;
}

#no-balance-synth {
    margin-bottom: 0.3em;
}

.advancedoptions {
    margin-top: 1em;
}

.advancedoptions+div fieldset {
    margin-top: 1em;
}

.advancedoptions+div legend {
    text-align: center;
}

#trade {
    margin-top: 1em;
}

#trade-btn {
    margin-top: 0em;
}

label[for='compoundpool1'],
label[for='2poolpool1'] {
    margin-left: -2px;
}

>>>.multiselect {
    width: 150px;
    cursor: pointer;
}

>>>.multiselect__tags {
    padding-top: 2px;
    padding-left: 3px;
    padding-bottom: 3px;
    background: silver;
    border-color: black;
    border-radius: 0;
    min-height: 0;
    border-right: none;
}

>>>.multiselect__single {
    background: silver;
    margin: 0;
}

>>>.multiselect__select {
    height: 26px;
}

>>>.multiselect__select:before {
    color: black;
    border-color: black transparent transparent;
}

>>>.multiselect__placeholder {
    margin-bottom: 1.5px;
}

.exchangefields ul {
    display: flex;
    flex-wrap: wrap;
}

.currencyInput {
    flex: 2;
}

>>>.multiselect__input {
    background: transparent;
    margin-bottom: 0;
    color: black;
}

>>>.multiselect__content-wrapper {
    background: white;
    border-radius: 0;
}

>>>.multiselect__content {
    margin-top: 5px;
}

>>>.multiselect__placeholder {
    color: black;
}

>>>.multiselect__option {
    padding: 5px;
    min-height: 20px;
}

>>>.multiselect__option--highlight,
>>>.multiselect__option--selected {
    background: #3465a4e6;
}

>>>.multiselect .multiselect__option--selected .option__title {
    color: white;
}

>>>.multiselect .option__title {
    vertical-align: middle;
    color: black;
    font-size: 14px;
}

>>>.multiselect__element {
    /*height: 30px;*/
}

.currencyInput input {
    height: 22px;
    font-size: 12.5pt;
}

.button-container {
    padding-top: 1em;
    text-align: center;
}

.buttoncancel {
    margin-right: 1em;
}

.buttonred {
    background: red;
    border: 1px outset red;
}

.buttonred:hover {
    background: red;
    border: 1px outset red;
}

.modal-content.failed-gas-estimation {
    width: 400px;
}

.price-impact.red {
    font-weight: bold;
    color: red;
}

@media only screen and (max-device-width: 1200px) {
    .exchange {
        width: 100%;
    }
}

@media only screen and (max-device-width: 800px) {
    .exchange .multiselect {
        width: 100%;
        min-height: 0;

    }

    >>>.multiselect__tags {
        padding-top: 2px;
        padding-left: 3px;
        padding-bottom: 3px;
        background: silver;
        border-color: black;
        border-radius: 0;
        min-height: 0;
        border-right: 1px solid black;
        border-bottom: none;
    }

    .maxbalance2 {
        display: none;
    }

    .currencyInput input {
        box-sizing: border-box;
        height: 26px;
    }
}
</style>
